import { useTranslation } from 'react-i18next';
import type { DashboardStats } from '@/api/types';
import type { DrillDownKind } from './types';

interface OccupancyOverviewCardProps {
  stats: DashboardStats;
  onSelect: (kind: DrillDownKind) => void;
}

export function OccupancyOverviewCard({ stats, onSelect }: OccupancyOverviewCardProps) {
  const { t } = useTranslation();

  return (
    <div className="bg-white rounded-xl p-5 shadow-sm border border-gray-100">
      <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wide mb-3">{t('dashboard.occupancyOverview')}</h3>
      <div className="grid grid-cols-2 gap-3">
        <button
          type="button"
          onClick={() => stats.occupiedBeds > 0 && onSelect('OCCUPIED')}
          disabled={stats.occupiedBeds === 0}
          className="bg-teal-50 rounded-xl p-4 text-center hover:bg-teal-100 transition disabled:hover:bg-teal-50 disabled:cursor-default"
        >
          <p className="text-2xl font-bold text-teal-700">{stats.occupiedBeds}</p>
          <p className="text-xs text-teal-600 mt-1">{t('dashboard.occupancyOccupied')}</p>
        </button>
        <button
          type="button"
          onClick={() => stats.vacantBeds > 0 && onSelect('AVAILABLE')}
          disabled={stats.vacantBeds === 0}
          className="bg-green-50 rounded-xl p-4 text-center hover:bg-green-100 transition disabled:hover:bg-green-50 disabled:cursor-default"
        >
          <p className="text-2xl font-bold text-green-700">{stats.vacantBeds}</p>
          <p className="text-xs text-green-600 mt-1">{t('dashboard.occupancyAvailable')}</p>
        </button>
        <button
          type="button"
          onClick={() => stats.reservedBeds > 0 && onSelect('RESERVED')}
          disabled={stats.reservedBeds === 0}
          className="bg-amber-50 rounded-xl p-4 text-center hover:bg-amber-100 transition disabled:hover:bg-amber-50 disabled:cursor-default"
        >
          <p className="text-2xl font-bold text-amber-700">{stats.reservedBeds}</p>
          <p className="text-xs text-amber-600 mt-1">{t('dashboard.occupancyReserved')}</p>
        </button>
        <button
          type="button"
          onClick={() => stats.blockedBeds > 0 && onSelect('MAINTENANCE')}
          disabled={stats.blockedBeds === 0}
          className="bg-gray-100 rounded-xl p-4 text-center hover:bg-gray-200 transition disabled:hover:bg-gray-100 disabled:cursor-default"
        >
          <p className="text-2xl font-bold text-gray-700">{stats.blockedBeds}</p>
          <p className="text-xs text-gray-500 mt-1">{t('dashboard.occupancyMaintenance')}</p>
        </button>
      </div>
    </div>
  );
}
